import { LOYALTY_MAIN_LEVEL_BENEFIT_TRANSLATION_KEYS } from '../../constants'
import { LOYALTY_LEVEL_NAMES } from '../../constants/levelNames'
import { LoyaltyLevelType, LoyaltyLevelWithRangeType } from '../../types'

export const getLevelsWithRanges = (levels: LoyaltyLevelType[]): LoyaltyLevelWithRangeType[] =>
  levels.map((level, index) => ({
    ...level,
    ftdRange: {
      from: level.ftd_count,
      to: levels[index + 1] ? levels[index + 1].ftd_count - 1 : Number.POSITIVE_INFINITY,
    },
    index,
    mainLevelBenefitTranslationKey: LOYALTY_MAIN_LEVEL_BENEFIT_TRANSLATION_KEYS[level.name as LOYALTY_LEVEL_NAMES] ?? null,
  }))
